import { Method } from 'axios';
import { Executable } from '../executable';
import { WalletUploadLocation } from '../interfaces';

/**
 * Get a list of upload locations to use for uploading images to the wallet.
 */
export class GetImageUploadLocations extends Executable<WalletUploadLocation[]> {
  /**
   * The brandId of the brand to retrieve upload locations for.
   */
  public brandId: number;

  /**
   * The number of images you want to upload.  Defaults to 1
   */
  public amount: number = 1;

  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): WalletUploadLocation[] {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    return `/${this.brandId}/uploads/temporary-upload?amount=${this.amount}`;
  }

  constructor(brandId: number, amount?: number) {
    super();
    this.brandId = brandId;
    if (amount) {
      this.amount = amount;
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
